<!--element 历史事件-->
<template>
	<div class="elEventBody">
		<div class="page_top_form">
			<el-form ref="form" label-width="80px">
				<el-form-item label="事件类型">
					<el-select v-model="form.eventType" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
						<el-option label='全选' value='全选' @click.native='selectAll'></el-option>
						<el-option v-for="item in getEventTypes" :key="item.id" :label="item.name" :value="item.no">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker v-model="form.dataTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<!--<el-button type="primary" size="mini">所有设备</el-button>-->
					<el-button type="primary" size="mini" @click="searchEvents()">查看</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="elEvent_bottom">
			<el-table :data="eventList" style="width: 100%" border height="802" v-loading="loading">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="linkobject" label="关联对象" width="200">
				</el-table-column>
				<el-table-column prop="eventlevel" label="等级" width="60" :formatter="formatEventLevel">
				</el-table-column>
				<el-table-column prop="typeName" label="类型" width="80">
				</el-table-column>
				<el-table-column prop="time" label="时间" :formatter="formatTime">
				</el-table-column>
				<el-table-column prop="description" label="内容" width="380">
				</el-table-column>
				<el-table-column prop="eventstate" label="状态" :formatter="formatterEventState">
				</el-table-column>
				<el-table-column prop="confirmuser" label="确认人">
				</el-table-column>
				<el-table-column prop="confirmtime" label="确认时间" :formatter="formatTimeConfirm">
				</el-table-column>
				<el-table-column  label="操作" width="120">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="confirmEvent(scope.row)">确认事件</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!--分页-->
			<elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange" @handleSizeChange="handleSizeChange" />
		</div>
	</div>
</template>

<script>
	import elPagination from "@/components/module/elComponents/elPagination.vue"
	export default {
		components: {
			elPagination,
		},
		props: {},
		data() {
			return {
				form: {
					eventType: "",
					dataTime: [new Date(), new Date()],
				},
				eventList: [],
				state: -1,
				pageIndex: 1,
				pageSize: 20,
				total: 0,
				loading: false,
			}
		},
		created() {},
		mounted() {
			debugPage = this
			//默认全选
			this.form.eventType[0] = "全选"
			this.selectAll()
			this.searchEvents()
		},
		destroyed() {},
		computed: {
			eventStore() {
				return this.$store.eventStore
			},
			getEventTypes() {
				return this.eventStore.getters.searchAllEventTypes
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getLevelName() {
				return this.$store.eventStore.getters.getLevelName
			},
			getStateName() {
				return this.$store.eventStore.getters.getStateName
			},
		},
		watch: {
			eventList(nv, ov) {

			}
		},
		methods: {
			formatEventLevel(row, column, cellValue) {
                return this.getLevelName(row.eventlevel)
			},
			formatterEventState(row, column, cellValue){
				return this.getStateName(row.eventstate)
			},
			formatTime(row, column, cellValue) {
				return new Date(row.time).format('yyyy/MM/dd hh:mm:ss')
			},
			formatTimeConfirm(row, column, cellValue){
				if(!isempty(row.confirmtime)){
					return new Date(row.confirmtime).format('yyyy/MM/dd hh:mm:ss')
				}
			},
			selectAll() {
				if(this.form.eventType[0] == "全选") {
					this.getEventTypes.forEach(item => {
						this.form.eventType.push(item.no)
					})
				} else {
					this.form.eventType = []
				}
			},
			//当前页
			pageindexChange(val) {
				this.pageIndex = val;
				this.searchEvents()
			},
			//页大小
			handleSizeChange(val) {
				this.pageSize = val;
				this.pageIndex = 1;
				this.searchEvents()
			},
			confirmEvent(row){
				//确认事件
				this.$api.eventApi.confirmEventByEventNo(row.no,respon=>{
					this.$message.success("确认成功")
					this.searchEvents()
				},respon=>{
					this.$message.warning("确认失败")
				})
			},
			searchEvents() {
				//查询事件
				if(isempty(this.form.eventType)) {
					//事件类型为空
					this.$message.warning("事件类型不能为空")
					return
				}
				let eventTypeNos = ""
				let bgTime = this.form.dataTime[0].getTime()
				let endTime = this.form.dataTime[1].getTime()
				this.form.eventType.forEach((item, index) => {
					if(item != "全选") {
						index + 1 < this.form.eventType.length ? eventTypeNos += item + "," : eventTypeNos += item
					}
				})
				this.loading=true
				this.$api.eventApi.searchEventListByUser(undefined, this.nowUnit.id, eventTypeNos, this.state, -1, getValueIfNoNull(this.nowDevice, {}).no, bgTime, endTime, this.pageIndex, this.pageSize, '', respon => {
					this.total = respon.total
					this.eventList = respon.data
					this.loading=false
				})
			},
		}
	}
</script>

<style scoped>
	.elEventBody {
		width: 100%;
		height: 100%;
		background-color: white;
	}
	
	.elEvent_bottom {
		padding: 0 20px 0 20px;
		height: calc(100% - 73px);
	}
	
	.elEvent_bottom .Pagination {
		width: 98%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		height: 5%;
		background-color: white;
		margin-top: .1rem;
	}
</style>